export type FormListEvent = 'DELETE' | 'EDIT' | 'STATS' | 'PREVIEW' | 'SAMPLE';

export const DELETE = 'DELETE';
export const EDIT = 'EDIT';
export const STATS = 'STATS';
export const PREVIEW = 'PREVIEW';
export const SAMPLE = 'SAMPLE';